import type { FC } from 'react';

import { Stack, Text } from '@eneco/sparky';
import { DotIcon } from '@eneco/sparky/icons';
import { FeedbackColors } from '@eneco/sparky/types';

interface Props {
  color: Extract<keyof FeedbackColors, 'feedbackSuccess' | 'feedbackWarning' | 'feedbackError'>;
  children: string;
}

export const StatusIndicator: FC<Props> = ({ color, children }) => (
  <Stack direction="row" gap="1" alignY="center">
    <DotIcon color={color} />
    <Text size={{ initial: 'BodyS', md: 'BodyM' }} color="textLowEmphasis">
      {children}
    </Text>
  </Stack>
);
